import Api, { make, Response } from 'src/services/api'

import { Id, Policy, PolicyAntiFraud, PolicyRule } from 'src/types'

type Data = {
  policies: Policy[]
  total_results: number
}

type GetAllProps = {
  organization_id: Id
  page: number
  withInactive?: boolean
}

type GetByIdProps = {
  organization_id: Id
  policy_id: Id
}

type SaveProps = {
  organization_id: Id
  policy: Policy
}

export const PAGE_SIZE = 10

export function getAll({
  organization_id,
  page,
  withInactive = false
}: GetAllProps): Promise<Response<Data>> {
  return make<Data>({
    axiosCall: Api.get(
      `organizations/${organization_id}/policies?page_size=${PAGE_SIZE}&page=${
        page || 1
      }${withInactive ? '&active=True' : ''}`
    )
  })
}

export function getById({
  organization_id,
  policy_id
}: GetByIdProps): Promise<Response<Policy>> {
  return make<Data, Policy>({
    axiosCall: Api.get(
      `organizations/${organization_id}/policies?policy_id=${policy_id}`
    ),
    transformData: data => data.policies[0]
  })
}

export function save({
  organization_id,
  policy
}: SaveProps): Promise<Response<Policy>> {
  return make<Pick<Data, 'policies'>, Policy>({
    axiosCall: Api.post(`organizations/${organization_id}/policies`, {
      policies: [policy]
    }),
    transformData: data => data.policies[0]
  })
}

interface PolicyAntiFraudResponse {
  policies: PolicyAntiFraud[]
}

export function getAntiFraudList({
  organization_id
}: {
  organization_id: Id
}): Promise<Response<PolicyAntiFraudResponse>> {
  return make<PolicyAntiFraudResponse>({
    axiosCall: Api.get(`antifraud/${organization_id}/policies`)
  })
}

interface SaveAntiFraudResponse {
  policy_request_receipt_antifrauds: PolicyAntiFraud[]
}

interface SaveAntiFraudProps {
  organization_id: Id
  record: PolicyAntiFraud
}

export function saveAntiFraud({
  organization_id,
  record
}: SaveAntiFraudProps): Promise<Response<SaveAntiFraudResponse>> {
  return make<SaveAntiFraudResponse>({
    axiosCall: Api.post(`antifraud/${organization_id}/policies`, record)
  })
}

type PolicyRules = Pick<PolicyRule, 'policy_rule_id' | 'name'>

interface GetPolicyRulesResponse {
  policy_rules: [PolicyRules]
}

export function getPolicyRules({
  organization_id
}: {
  organization_id: Id
}): Promise<Response<GetPolicyRulesResponse>> {
  return make({
    axiosCall: Api.get(`organizations/${organization_id}/policy_rules`)
  })
}
